import { Button } from '@amzn/awsui-components-react';
import { Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import {
  isMidwaySessionExpired,
  MIDWAY_LOGIN_LABEL,
  onMidwaySessionChange,
} from '../../../client/piezo/signing/midwaySession';
import { isPiezoEnabledEnvironment } from '../../../client/piezo/signing/environment';

/**
 * Re-authenticates the operator after their Midway session expires. Renders only once an expiry has been
 * recorded, and only where Piezo runs.
 *
 * Signs in through the Cognito identity provider, which federates to Midway. Navigates only on click.
 */
export const MidwayLoginButton = () => {
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    if (!isPiezoEnabledEnvironment()) {
      return undefined;
    }
    setExpired(isMidwaySessionExpired());
    return onMidwaySessionChange(() => setExpired(isMidwaySessionExpired()));
  }, []);

  if (!expired) {
    return null;
  }

  return (
    <Button
      iconName="lock-private"
      variant="primary"
      onClick={() => Auth.federatedSignIn({ customProvider: 'Amazon' })}
    >
      {MIDWAY_LOGIN_LABEL}
    </Button>
  );
};
